import MediaQueryBreakpoints from '@/v2/constants/MediaQueryBreakpoints';
import styled from 'styled-components';

export default function RadioGroup({
  variant = 'horizontal',
  size = 'default',
  children,
}) {
  return (
    <StyledRadioGroup variant={variant} size={size}>
      {children}
    </StyledRadioGroup>
  );
}

const StyledRadioGroup = styled.div`
  display: flex;
  flex-direction: ${(props) =>
    props.variant == 'vertical' ? 'column' : 'row'};
  gap: ${(props) => (props.size == 'compact' ? '8px' : '24px')};
  width: 100%;

  @media (${MediaQueryBreakpoints.isUltraWide}) {
    gap: ${(props) => (props.size == 'compact' ? '8px' : '16px')};
  }
`;
